<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { getProjectType, fetchAllMenu } from '@/api/common'
import common from '@/utils/common'
import SvgIcon from '@/components/SvgIcon/index.vue'

const NODE_ENV = import.meta.env.VITE_APP_ENV

const {
  VITE_APP_MJ_KF_ORIGIN,
  VITE_APP_MJ_CLOUD_ORIGIN,
  VITE_APP_MJ_CLOUD_EDU_ORIGIN,
  VITE_APP_SG_KF_ORIGIN,
  VITE_APP_SG_CLOUD_ORIGIN,
  VITE_APP_SG_CLOUD_EDU_ORIGIN
} = import.meta.env

let kfOrigin = ref('')
let cloudOrigin = ref('')
let cloudEduOrigin = ref('')

if (common.getWebName() === 'mj') {
  kfOrigin.value = VITE_APP_MJ_KF_ORIGIN
  cloudOrigin.value = VITE_APP_MJ_CLOUD_ORIGIN
  cloudEduOrigin.value = VITE_APP_MJ_CLOUD_EDU_ORIGIN
} else if (common.getWebName() === 'sg') {
  kfOrigin.value = VITE_APP_SG_KF_ORIGIN
  cloudOrigin.value = VITE_APP_SG_CLOUD_ORIGIN
  cloudEduOrigin.value = VITE_APP_SG_CLOUD_EDU_ORIGIN
}

// 数据初始化
const activeIndex = ref()
const allMenu = ref([])
const menus = [
  {
    index: '2',
    title: '云流程',
    key: 'flow',
    url: `${kfOrigin.value}/flow`
  },
  {
    index: '3',
    title: '云工具',
    key: 'tools',
    url: `${kfOrigin.value}/tools`
  },
  {
    index: '4',
    title: '云课堂',
    key: 'edu',
    url: `${cloudEduOrigin.value}`
  },
  {
    index: '5',
    title: '云文库',
    key: 'wenku',
    url: `${kfOrigin.value}/wenku`
  },
  {
    index: '6',
    title: '产品商城',
    key: 'shop',
    url: `${kfOrigin.value}/shop`
  }
]

const menusSg = [
  {
    index: '6',
    title: '科研产品',
    key: 'shop',
    url: `${kfOrigin.value}/shop`
  },
  {
    index: '2',
    title: '云流程',
    key: 'flow',
    url: `${kfOrigin.value}/flow`
  },
  {
    index: '3',
    title: '云工具',
    key: 'tools',
    url: `${kfOrigin.value}/tools`
  },
  {
    index: '4',
    title: '云课堂',
    key: 'edu',
    url: `${kfOrigin.value}/edu`
  },
  {
    index: '5',
    title: '云文库',
    key: 'wenku',
    url: `${kfOrigin.value}/wenku`
  }
]

const handleSelect = (key: string, keyPath: string[]) => {
  console.log(key, keyPath)
}

// 导航跳转
const toNav = (link: string) => {
  window.location.href = link
}

// 一二级菜单跳转
const toLink = (item: any) => {
  window.location.href = item.url
}

// 获取导航栏的一二级菜单
const getAllMenu = () => {
  fetchAllMenu({}).then((res: any) => {
    let { c, d } = res
    if (c === 0) {
      allMenu.value = d

      // 文库的菜单格式比较另类，需要特殊处理
      const arr1 = allMenu.value['wenku']
      // 转换为数组
      const arr2 = Object.values(arr1)
      if (arr2.length) {
        const arr3 = arr2.reduce((acc, item, index) => {
          if (index % 2 === 0) {
            acc.push({ children: [item] })
          } else {
            acc[acc.length - 1].children.push(item)
          }
          return acc
        }, [])
        allMenu.value['wenku'] = arr3
      }
    }
  })
}
onMounted(() => {
  getAllMenu()
})
</script>

<template>
  <template v-if="common.getWebName() === 'mj'">
    <el-menu
      :default-active="activeIndex"
      mode="horizontal"
      @select="handleSelect"
      class="flex-1 layout-menu"
      popper-class="navbar-popper"
    >
      <el-menu-item index="1" @click="toNav(`${kfOrigin}/web/www/index`)"
        >首页</el-menu-item
      >

      <!-- 通用子菜单组件 -->
      <el-sub-menu
        v-for="(menu, index) in menus"
        :key="menu.index"
        :index="menu.index"
        @click="toNav(menu.url)"
      >
        <template #title>{{ menu.title }}</template>
        <div
          v-for="(item, itemIndex) in allMenu[menu.key]"
          :key="itemIndex"
          class="sub-menu"
        >
          <p class="sub-title" v-if="item.name" @click="toLink(item)">
            {{ item.name }}
          </p>
          <ul>
            <li
              v-for="(subItem, subIndex) in item.children"
              :key="subIndex"
              @click="toLink(subItem)"
            >
              {{ subItem.name }}
            </li>
          </ul>
        </div>
      </el-sub-menu>

      <el-menu-item index="7" @click="toNav(`${kfOrigin}/article/index`)"
        >项目文章</el-menu-item
      >
    </el-menu>

    <ul>
      <li v-for="(item, index) in allMenu" :key="index" @click="toLink(item)">
        {{ item.name }}
      </li>
    </ul>
  </template>

  <template
    v-if="common.getWebName() === 'sg' || common.getWebName() === 'local'"
  >
    <el-menu
      :default-active="activeIndex"
      mode="horizontal"
      @select="handleSelect"
      class="flex-1 layout-menu layout-menu-sg"
    >
      <el-menu-item index="1" @click="toNav(`${kfOrigin}/web/www/index`)"
        >首页</el-menu-item
      >

      <!-- 通用子菜单组件 -->
      <el-sub-menu
        v-for="(menu, index) in menusSg"
        :key="menu.index"
        :index="menu.index"
        :popper-class="['navbar-popper-sg', `navbar-popper-sg-${menu.index}`]"
        @click="toNav(menu.url)"
      >
        <template #title
          >{{ menu.title }}
          <el-icon :size="12"><CaretBottom /></el-icon>
        </template>
        <div
          v-for="(item, itemIndex) in allMenu[menu.key]"
          :key="itemIndex"
          class="sub-menu"
        >
          <p
            class="sub-title mj-theme-ft-hover"
            v-if="item.name"
            @click="toLink(item)"
          >
            <!-- 云流程 -->
            <SvgIcon
              v-if="menu.title === '云流程'"
              :name="`navigation/ylc_${itemIndex}`"
            />
            <!-- 云课堂 -->
            <SvgIcon
              v-if="menu.title === '云课堂'"
              :name="`navigation/ykt_${itemIndex}`"
            />
            {{ item.name }}
          </p>
          <ul>
            <li
              v-for="(subItem, subIndex) in item.children"
              :key="subIndex"
              @click="toLink(subItem)"
            >
              {{ subItem.name }}
            </li>
          </ul>
        </div>
      </el-sub-menu>

      <el-menu-item index="7" @click="toNav(`${kfOrigin}/article/index`)"
        >项目文章</el-menu-item
      >
    </el-menu>

    <ul>
      <li v-for="(item, index) in allMenu" :key="index" @click="toLink(item)">
        {{ item.name }}
      </li>
    </ul>
  </template>
</template>

<style lang="scss">
.ep-popper.navbar-popper-sg {
  border: none !important;
  border-radius: 0;
  inset: 70px auto auto 0px !important;
  width: 100%;
  border: none;
  box-sizing: border-box;
  padding-top: 30px !important;
  padding-bottom: 40px !important;
  background: #ffffff !important;
  box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);
  border-top: 1px solid #dedede;
  backdrop-filter: blur(5px);
  .navbar-popper-sg-3 {
    justify-content: flex-start;
    padding-left: 265px;
    .sub-menu {
      width: 130px;
    }
  }
  .navbar-popper-sg-4 {
    justify-content: flex-start;
    padding-left: 350px;
    .sub-menu {
      width: 130px;
    }
  }
  .navbar-popper-sg-5 {
    justify-content: flex-start;
    padding-left: 590px;
    .sub-menu {
      width: 130px;
    }
  }
  .svg-icon {
    width: 24px;
    height: 24px;
    vertical-align: -6px;
    margin-right: 5px;
  }
  .sub-menu {
    width: 192px;
    padding: 0 15px;
    p,
    li {
      color: #282a2d;
      line-height: 34px;
      cursor: pointer;
    }
    li {
      transition: all 0.1s ease-in-out;
      font-size: 14px;
      &:hover {
        color: #07be84;
      }
    }
  }
  .ep-popper {
    &.navbar-popper-sub {
      padding-left: 35px !important;
      border: none !important;
      border-left: 1px solid #07be84 !important;
      border-radius: 0;
    }
    &.inset-1 {
      inset: -73px auto auto 125px !important;
    }
    &.inset-2 {
      inset: -110px auto auto 125px !important;
    }
  }
  .ep-menu {
    background-color: transparent;
    box-shadow: none;
    height: auto;
    display: flex;
    justify-content: center;
    width: 100%;
    flex-wrap: wrap;
    .sub-title {
      font-size: 16px;
      margin-bottom: 16px;
      border-bottom: 1px solid #e8e8e8;
      padding-bottom: 16px;
      i {
        width: 20px;
        height: 20px;
        display: inline-block;
        background: url(../../../assets/svg/user/person.svg) no-repeat;
        background-size: 13px;
        color: #07be84;
      }
    }
    .ep-menu-item,
    .ep-sub-menu {
      position: relative;
      color: #282a2d !important;
      padding-left: 15px !important;
      margin-right: 100px;
      &::before {
        content: '';
        position: absolute;
        left: 0px;
        top: 50%;
        margin-top: -2px;
        display: inline-block;
        width: 4px;
        height: 4px;
        border-radius: 4px;
        background-color: #07be84;
      }

      .ep-sub-menu__title {
        padding-left: 0;
      }
    }
  }
}
</style>
